import "./MarkdownContent.css";

import PropTypes from "prop-types";
import React from "react";

const MarkdownContent = ({ html, className }) => {
  const cls = ["markdown-body", className].filter(Boolean).join(" ");
  return (
    <div
      className={cls}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: html || "" }}
    />
  );
};

MarkdownContent.propTypes = {
  className: PropTypes.string,
  html: PropTypes.string,
};

export default MarkdownContent;
